import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useRef, useState } from "react";
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, styled } from "@mui/material";
import { KeyboardArrowLeft, MoreVert } from "@mui/icons-material";
import { StyledDiv, FilledTextArea } from "./CalculatorStyled";
import { msgs } from "./CalculatorL10n";
const parentSx = {
    backgroundColor: "background.default",
    color: "text.primary",
    position: "relative",
    display: "flex",
    minHeight: "0",
    overflowY: "hidden",
};
const textSx = {
    backgroundColor: "background.default",
    color: "text.primary",
    fontSize: "32px",
    margin: "0",
    resize: "none",
    border: "none",
    display: "block",
    width: "100%",
    height: "100%",
    minHeight: "0",
};
const MenuContainer = styled("div")({
    display: "flex",
    height: "100%",
    alignItems: "flex-start",
    justifyContent: "flex-end",
});
const anchorTR = {
    vertical: "top",
    horizontal: "right",
};
export default memo((props) => {
    const [menuAnchor, setMenuAnchor] = useState(null);
    const [anglesAnchor, setAnglesAnchor] = useState(null);
    const [radixAnchor, setRadixAnchor] = useState(null);
    const menuButtonRef = useRef(null);
    const openMenu = useCallback(() => {
        setAnglesAnchor(null);
        setRadixAnchor(null);
        setMenuAnchor(menuButtonRef.current);
    }, []);
    const closeMenu = useCallback(() => {
        setMenuAnchor(null);
    }, []);
    const openAnglesMenu = useCallback(() => {
        setMenuAnchor(null);
        setAnglesAnchor(menuButtonRef.current);
    }, []);
    const closeAnglesMenu = useCallback(() => {
        setAnglesAnchor(null);
    }, []);
    const mapAngles = useCallback((unit) => {
        switch (unit) {
            case "deg" /* AngleUnit.deg */:
                return msgs[14 /* S.cpp_deg */];
            case "rad" /* AngleUnit.rad */:
                return msgs[15 /* S.cpp_rad */];
            case "grad" /* AngleUnit.grad */:
                return msgs[16 /* S.cpp_grad */];
            case "turns" /* AngleUnit.turns */:
                return msgs[17 /* S.cpp_turns */];
        }
    }, []);
    const wrapAngleClick = (unit) => useCallback(() => { props.setAngleUnit(unit); closeAnglesMenu(); }, [props.setAngleUnit]);
    const openRadixMenu = useCallback(() => {
        setMenuAnchor(null);
        setRadixAnchor(menuButtonRef.current);
    }, []);
    const closeRadixMenu = useCallback(() => {
        setRadixAnchor(null);
    }, []);
    const mapRadix = useCallback((base) => {
        switch (base) {
            case "bin" /* NumeralBase.bin */:
                return msgs[18 /* S.cpp_bin */];
            case "oct" /* NumeralBase.oct */:
                return msgs[19 /* S.cpp_oct */];
            case "dec" /* NumeralBase.dec */:
                return msgs[20 /* S.cpp_dec */];
            case "hex" /* NumeralBase.hex */:
                return msgs[21 /* S.cpp_hex */];
        }
    }, []);
    const openAbout = useCallback(() => {
        setMenuAnchor(null);
        props.openAbout();
    }, [props.openAbout]);
    const wrapRadixClick = (base) => useCallback(() => {
        props.setNumeralBase(base);
        closeRadixMenu();
    }, [props.setNumeralBase]);
    return (_jsxs(StyledDiv, { sx: parentSx, children: [_jsx(FilledTextArea, { sx: textSx, inputMode: "none", readOnly: props.readonly, ref: props.textRef, defaultValue: props.defaultValue, value: props.value, onBlur: props.textOnBlur, onFocus: props.textOnFocus, onInput: props.textOnInput }), _jsxs(MenuContainer, { children: [_jsx(IconButton, { onClick: openMenu, ref: menuButtonRef, children: _jsx(MoreVert, {}) }), _jsxs(Menu, { anchorEl: menuAnchor, anchorOrigin: anchorTR, transformOrigin: anchorTR, open: menuAnchor !== null, onClose: closeMenu, children: [_jsxs(MenuItem, { onClick: openAnglesMenu, children: [_jsx("b", { children: msgs[12 /* S.cpp_angles */] }), ": ", mapAngles(props.angleUnit)] }), _jsxs(MenuItem, { onClick: openRadixMenu, children: [_jsx("b", { children: msgs[13 /* S.cpp_radix */] }), ": ", mapRadix(props.numeralBase)] }), _jsx(MenuItem, { onClick: props.openHistoryPage, children: msgs[22 /* S.c_history */] }), _jsx(MenuItem, { onClick: openAbout, children: msgs[1 /* S.cpp_about */] })] }), _jsxs(Menu, { anchorEl: anglesAnchor, anchorOrigin: anchorTR, transformOrigin: anchorTR, open: anglesAnchor !== null, onClose: closeAnglesMenu, children: [_jsxs(MenuItem, { onClick: openMenu, children: [_jsx(ListItemIcon, { children: _jsx(KeyboardArrowLeft, { fontSize: "small" }) }), _jsx(ListItemText, { children: msgs[12 /* S.cpp_angles */] })] }), _jsx(MenuItem, { onClick: wrapAngleClick("deg" /* AngleUnit.deg */), children: msgs[14 /* S.cpp_deg */] }), _jsx(MenuItem, { onClick: wrapAngleClick("rad" /* AngleUnit.rad */), children: msgs[15 /* S.cpp_rad */] }), _jsx(MenuItem, { onClick: wrapAngleClick("grad" /* AngleUnit.grad */), children: msgs[16 /* S.cpp_grad */] }), _jsx(MenuItem, { onClick: wrapAngleClick("turns" /* AngleUnit.turns */), children: msgs[17 /* S.cpp_turns */] })] }), _jsxs(Menu, { anchorEl: radixAnchor, anchorOrigin: anchorTR, transformOrigin: anchorTR, open: radixAnchor !== null, onClose: closeRadixMenu, children: [_jsxs(MenuItem, { onClick: openMenu, children: [_jsx(ListItemIcon, { children: _jsx(KeyboardArrowLeft, { fontSize: "small" }) }), _jsx(ListItemText, { children: msgs[13 /* S.cpp_radix */] })] }), _jsx(MenuItem, { onClick: wrapRadixClick("bin" /* NumeralBase.bin */), children: msgs[18 /* S.cpp_bin */] }), _jsx(MenuItem, { onClick: wrapRadixClick("oct" /* NumeralBase.oct */), children: msgs[19 /* S.cpp_oct */] }), _jsx(MenuItem, { onClick: wrapRadixClick("dec" /* NumeralBase.dec */), children: msgs[20 /* S.cpp_dec */] }), _jsx(MenuItem, { onClick: wrapRadixClick("hex" /* NumeralBase.hex */), children: msgs[21 /* S.cpp_hex */] })] })] })] }));
});
